import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import * as React from 'react';

/**
 * Example replacement: 
 * if (domNode.name === 'p') {
		return <div>{domNode.children}</div>;
	}
 */
export function replaceNode() {} // custom code for replacement

export const HtmlParserComponent = ({ html, options = {} }: { html: string; options?: any }) => {
	if (!html) return null;

	const parsedHtml = HtmlParser(html, options);

	return <>{parsedHtml}</>;
};

const HtmlParser = (html: string | null | undefined, opts = {}) => {
	if (!html) return null;

	const parsed = parse(DOMPurify.sanitize(html), {
		// ...{
		//     replace: replaceNode,
		// },
		...opts,
	});

	return parsed;
};

export default HtmlParser;

export const HtmlToTextParser = (htmlContent: string) => {
	if (!htmlContent) return '';

	htmlContent = htmlContent.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, '');
	htmlContent = htmlContent.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, '');
	// Remove all HTML tags
	let text = htmlContent.replace(/<\/?[^>]+(>|$)/g, '');
	// Decode HTML entities
	text = text
		.replace(/&nbsp;/gi, ' ')
		.replace(/&amp;/gi, '&')
		.replace(/&quot;/gi, '"')
		.replace(/&lt;/gi, '<')
		.replace(/&gt;/gi, '>')
		.replace(/&apos;/gi, "'")
		.replace(/&#(\d+);/gi, (_match, numStr) => String.fromCharCode(parseInt(numStr, 10)))
		// Remove invisible characters and normalize whitespace
		.replace(/[\u0000-\u001F\u007F-\u009F]/g, '') // Remove control characters
		.replace(/\s+/g, ' ') // Replace multiple whitespace with single space
		.trim(); // Remove leading and trailing whitespace

	return text;
};
